import React from 'react';
import { FormComponent, FormComponentProps } from '../index';
import { useFormContext } from 'react-hook-form';

export default function Hidden(name: string): FormComponent {
  return ({ ...rest }) => <HiddenComponent name={name} {...rest} />;
}

export function HiddenComponent({
  name,
  parentName,
  readonly,
  disabled,
  required,
}: FormComponentProps & {
  name: string;
}) {
  const { register } = useFormContext();
  const inputName = parentName ? `${parentName}.${name}` : name;

  if (readonly) {
    return (
      <input
        type={'hidden'}
        name={inputName}
        {...register(inputName)}
        readOnly={readonly}
        disabled={disabled}
      />
    );
  } else {
    return (
      <input
        type={'hidden'}
        name={inputName}
        {...register(inputName)}
        readOnly={readonly}
        disabled={disabled}
      />
    );
  }
}
